(function(angular){
	'use strict';
	
	angular
		.module('formValidationModule')
		.directive('wireMin', [
			'$parse',
			'FormValidationFactory',
			wireMinFunction
		]);
	
	function wireMinFunction($parse, FormValidationFactory) {
		return {
			require: '?ngModel',
			restrict: 'A',
			link: function($scope, $elem, $attrs, ngModel) {
				var amount;
				var wireMin;
				var isValid;

				function checkValidity() {
					amount = $parse($attrs.ngModel)($scope);
					wireMin = $parse($attrs.wireMin)($scope);
					var inputAmount = angular.isDefined(amount) && angular.isDefined(amount.value) ? amount.value : amount;

					if(angular.isDefined(inputAmount) && angular.isDefined(wireMin)) {
						isValid = inputAmount >= wireMin;
					} else {
						isValid = true;
					}

					ngModel.$setValidity('wireMin', isValid);
				}

				if(ngModel !== null) {
					$scope.$watch($attrs.ngModel, function() {
						checkValidity();
					});

					$scope.$watch($attrs.wireMin, function(newValue) {
						FormValidationFactory.publishErrorVarsToModel({
							wireMin: newValue
						}, ngModel);
						checkValidity();
					});
				}
			}
		};
	}
})(window.angular);